
define('modules/application/wizard/classes/exportMaterialList',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./exportElement"

],

function(app, Backbone, exportElement) {

  var exportMaterialList   = _.extend({}, exportElement, {

    Views : {
      titleBar  : exportElement.Views.titleBar.extend({
        afterRender  :  function() {
          this.$el.children(".titleBarcontent").prepend($.i18n._("IDS_W1_9021"));
        }
      }),
      content   : exportElement.Views.content.extend({

        events       : {
          "click .project-save" : "requestSaveproject",
          "click .project-pdf"  : "requestExport",
          "click #clipboardJSonSend"   : "clipboardJSonSendEventHandler",
          "click #clipboardJSonReceive": "clipboardJSonReceiveEventHandler"
        },

        initialize   :  function() {
          this.loader       = new window.BticinoS4B.Instances.Views.LoaderView({model:{quote : "IDS_W1_9095", closeButton : true}});
          this.model.get("eventAggregator").bind("loader:hide", this.hideLoader, this);
          this.model.get("eventAggregator").bind("loader:download", this.addDownloadView, this);
          this.insertView(".popups", this.loader);
        },

        storeCCVariable: function() {
          BticinoS4B.Instances.Models.ApplicationModel.set("projectName", this.$el.find("input[name='projectName']").val());
          BticinoS4B.Instances.Models.ApplicationModel.set("projectTicket", this.$el.find("input[name='projectTicket']").val());
          BticinoS4B.Instances.Models.ApplicationModel.set("projectNote", this.$el.find("textarea[name='projectNote']").val());
        },

        requestExport:  function() {
          this.storeCCVariable();
          this.loader.render();
          this.loader.show(this.triggerRequestExport, undefined, this);
        },

        requestSaveproject: function() {
          this.storeCCVariable();
          window.BticinoS4B.Instances.Views.headerView.savePopup.show();
        },

        triggerRequestExport : function() {
          window.BticinoS4B.eventAggregator.trigger("export:requested");
        },

        showDebugPrompt: function(text){
          window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
        },

        clipboardJSonSendEventHandler: function(){
          var text = JSON.stringify(BticinoS4B.Instances.Models.ApplicationModel.get("lastReportMaterialSend"));
          var res = BticinoS4B.jsbeautifier.js_beautify(text);
          this.showDebugPrompt(res);
        },
        
        clipboardJSonReceiveEventHandler: function(){
          var text = JSON.stringify(BticinoS4B.Instances.Models.ApplicationModel.get("lastReportMaterialResponse"));
          var res = BticinoS4B.jsbeautifier.js_beautify(text);
          this.showDebugPrompt(res);
        },

        hideLoader   :  function() {
          this.loader.hide();
        },

        addDownloadView : function() {
          var loaderView = this.loader;
          var title      = loaderView.$el.find(".header p");
          var that       = this;

          loaderView.$el.find(".content").fadeOut("100", function() {
            var content = loaderView.$el.find(".content");
            content.html("");
            content.append("<a data-bypass target=\"_blank\" href=\""+that.model.get("pdfUrl")+"\" class=\"download-button dataBypass\"><button class=\"orange-button\">Download</button></a>");
            content.fadeIn("100");
            content.find(".download-button").bind("click", function(e) {
              e.preventDefault();
              loaderView.hide();
              window.open(that.model.get("pdfUrl"));
            });
          });

          title.fadeOut("100", function() {
            title.text($.i18n._("IDS_W1_9096"));
            title.fadeIn("100", function() {$.colorbox.resize();});
          });
        },

        afterRender  :  function() {
          if (window.BticinoS4B.Instances.Models.loginModel.get('category') === 'CC') {
            this.$el.children(".first").prepend(
                '<section style="margin-bottom: 3px;">'+
                '  <div class="text inputLabel">' + $.i18n._("IDS_W4_9003") +':</div> '+
                '  <input type="text" name="projectName" maxlength="40" /> '+
                '</section> '+
                '<section style="margin-bottom: 3px;">'+
                '  <div class="text inputLabel">Ticket:</div> '+
                '  <input type="text" name="projectTicket" maxlength="25" /> '+
                '</section> '+
                '<section style="margin-bottom: 3px;">'+
                '  <div class="text inputLabel">Note:</div> '+
                '  <textarea name="projectNote" rows="5" cols="40" /> '+
                '</section>');
            this.$el.children(".first").children(".button-list").append("<li><button class='project-save' style='min-width: 160px;'><img src='/assets/img/floppy-icon.png' style='width: 23px;'/><p class='text'>Salva progetto</p></button></li>");
          }

          this.$el.children("a").prepend($.i18n._("IDS_W1_9021"));
          this.$el.children(".first").children(".button-list").append("<li><button class='project-pdf'><img src='/assets/img/adobe-logo.png' /><p class='text'>"+$.i18n._("IDS_W1_9021")+"</p></button></li>");


          if (BticinoS4B.devMode.enabled){
            this.$el.children(".first").children(".button-list").append('<li><button id="clipboardJSonSend">JSon Send</button></li>');
            this.$el.children(".first").children(".button-list").append('<li><button id="clipboardJSonReceive">JSon Receive</button></li>');
          }

        }

      })
    },

    Model       : exportElement.Model.extend({
      defaults    :  {
        eventAggregator : _.extend({}, Backbone.Events),
        quoteIds        : "IDS_WGENTT_000048"
      },

      initialize  :  function() {
        window.BticinoS4B.eventAggregator.bind("export:requested", this.generateReport, this);
      },

      generateReport : function() {
        var that         = this,
            dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider");
        window.BticinoS4B.eventAggregator.trigger("modelDeliver:request",this);
        BticinoS4B.Instances.Models.ApplicationModel.startAutomaticCalculation();

        var dataToSend = {};
        var k          = 0, i=0;

        //Initial datas
        dataToSend.token         = window.BticinoS4B.token;
        dataToSend.configuration = {
          fileoutformat : "PDF",
          filerepx      : "BTReportThermo001"
        };

        //Header
        dataToSend.header        = {
          logo           : "",
          quote_n        : BticinoS4B.Instances.Models.ApplicationModel.get("projectId") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectId") : 0,
          quote_date     : BticinoS4B.Instances.Models.ApplicationModel.get("projectModified") ? moment(BticinoS4B.Instances.Models.ApplicationModel.get("projectModified")).format('L') : moment().format('L'),
          quote_pricelist: $.i18n._("IDS_W1_9076"),
          quote_operator : BticinoS4B.Instances.Models.loginModel.get("username"),
          quote_name     : BticinoS4B.Instances.Models.ApplicationModel.get("projectName")   ? BticinoS4B.Instances.Models.ApplicationModel.get("projectName")   : "quote",
          quote_note     : BticinoS4B.Instances.Models.ApplicationModel.get("projectNote")   ? BticinoS4B.Instances.Models.ApplicationModel.get("projectNote")   : "",
          quote_ticket   : BticinoS4B.Instances.Models.ApplicationModel.get("projectTicket") ? BticinoS4B.Instances.Models.ApplicationModel.get("projectTicket") : ""
        };

        //Footer
        dataToSend.footer       = {};

        //String
        dataToSend.string       = {
          "IDS_W1_9021"  :  $.i18n._("IDS_W1_9021"),
          "IDS_W1_9022"  :  $.i18n._("IDS_W1_9022"),
          "IDS_W1_9023"  :  $.i18n._("IDS_W1_9023"),
          "IDS_W1_9024"  :  $.i18n._("IDS_W1_9024"),
          "IDS_W1_9037"  :  $.i18n._("IDS_W1_9037"),
          "IDS_W1_9038"  :  $.i18n._("IDS_W1_9038"),
          "IDS_W1_9039"  :  $.i18n._("IDS_W1_9039"),
          "IDS_W1_9040"  :  $.i18n._("IDS_W1_9040"),
          "IDS_W1_9087"  :  $.i18n._("IDS_W1_9087")
        };

        //ItemListByPackage
        dataToSend.itemListByPackage = dataProvider.retrieveMaterialOverviewInReportVersion();

        //ItemListByProduct
        dataToSend.itemListByProduct = {
          productInPriceList : {
            section : $.i18n._("IDS_W1_9034"),
            items   : []
          },
          productNotInPriceList : {
            section : $.i18n._("IDS_W1_9094"),
            items   : []
          }
        };

        var materialList                                         = dataProvider.retrieveMaterialListInReportVersion();
        dataToSend.itemListByProduct.productInPriceList.items    = materialList.productsInPriceList;
        dataToSend.itemListByProduct.productNotInPriceList.items = materialList.productsNotInPriceList;

        //Total calculation
        var grandTotal      = dataProvider.getGrandTotal();

        dataToSend.generic  = {
          estimateAmount : grandTotal.toFixed(2)+ " €"
        };

        BticinoS4B.Instances.Models.ApplicationModel.set('lastReportMaterialSend', dataToSend);
        $.ajax({
          type        : "POST",
          datatype    : "json",
          contentType : "application/json",
          url         : "/btreport/JSonInterface.asmx/JSonMakeReportThermo",
          data        : JSON.stringify(dataToSend),
          success     : function(data) {
            BticinoS4B.Instances.Models.ApplicationModel.set('lastReportMaterialResponse', data);
            var pdfUrl = data.d.fileUrl;
            that.set("pdfUrl", pdfUrl);
            that.get("eventAggregator").trigger("loader:download");
          },
          error  :  function(e) {
            that.get("eventAggregator").trigger("loader:hide");
          }
        });
      }
    })
  });

  // Required, return the module for AMD compliance
  return exportMaterialList;

});